<div class="top">
  <div class="header flex justify-content-between lg:flex-nowrap flex-wrap">
    <div class="flex flex-wrap md:flex-nowrap flex-column md:flex-row align-items-center justify-between w-full gap-6">

      <a class="logo-link" (click)="onLogoClick()">
        <img 
          class="logo" 
          alt="EkapyLogo" 
          src="./assets/images/ekapylogo.png"
        />
      </a>
      <div class="header-title">
        <h2>ΣΥΣΤΗΜΑ ΔΙΑΛΕΙΤΟΥΡΓΙΚΟΤΗΤΑΣ</h2>
      </div>
    </div>
  </div>

  <hr class="shadow-1" />

  <div class="stage-message" *ngIf="isStageEnvironment">
    <i class="pi pi-info-circle"></i> ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ
  </div>
</div>
